import { rgbToHex } from '@mui/material/styles'

export const rgba = (color) => {
  return `rgba(${color})`
}

export const getPaletteColors = (palette, keys = false) => {
  if (!palette?.styles?.preColor) {
    return [];
  }

  if (keys) {
    return Object.keys(palette.styles.preColor).reduce((acc, color) => {
      const hex = rgbToHex(rgba(palette.styles.preColor[color]));
      acc[color] = hex;
      return acc;
    }, {});
  }

  return Object.keys(palette.styles.preColor).map((color) => {
    return rgbToHex(rgba(palette.styles.preColor[color]));
  });
};

export const extractRGBValues = (rgbString) => {
  // Remove 'rgb(' and ')' and split by ','
  return rgbString
    .replace(/rgb\(|\)/g, '')
    .split(',')
    .map(val => val.trim())
    .join(', ');
}